module.exports = __webpack_public_path__ + "img/originalmaso.854a3151.jpg";